import _ from 'lodash';

/** Background and playset images of every district, as stored in map state. */
function getMapImages(data) {
    return (data?.items ?? [])
        .flatMap((item) => [
            item.background,
            ...(item.locations ?? []).flatMap((location) => [
                location.img,
                location.imgOwned,
            ]),
        ])
        .filter(Boolean);
}

/** Media ids of map images still converting that have no processing result yet. */
export function getProcessingMediaIds(data, mediaStatuses) {
    return _.uniq(
        getMapImages(data)
            .filter(
                (img) =>
                    img.processingStatus === 'in_progress' &&
                    mediaStatuses[img.mediaId] === undefined,
            )
            .map((img) => img.mediaId),
    );
}

/** Copy of the map with processing results applied to its images. */
export function withMediaStatuses(data, mediaStatuses) {
    const copy = _.cloneDeep(data);
    for (const img of getMapImages(copy)) {
        if (mediaStatuses[img.mediaId] !== undefined) {
            img.processingStatus = mediaStatuses[img.mediaId];
        }
    }
    return copy;
}
